import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { useNavigate, useParams } from "react-router-dom";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import JustificationsforTransfer from "./JustificationsforTransfer";
import JustificationsforTransferForm from "./JustificationsforTransferForm";
import "./style.css";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import {
  DeleteProjectExtensionRequestDetails,
  GetListProjectExtensionRequestDetails,
} from "../../../Redux/Reducers/ReportStage/ProjectExtensionRequestDetails";
import ProjectExtensionRequestDetailsForm from "./ProjectExtensionRequestDetailsForm";
import {
  ApprovalOfExtensionRequest,
  ChangeStatusByUser,
  GetProjectModificationRequestsById,
  ProcedureForTransferRequest,
} from "../../../Redux/Reducers/ReportStage/ProjectModificationRequests";
import { HandelRoleTransfer } from "../../../Redux/Reducers/ReportStage/TransferRole";

const ProjectExtensionRequestDetails = (props) => {
  const HandelRoleTransferResult = useSelector(
    (state) => state.TransferRoleReducer.TransferRole
  );
  let location = window.location.pathname.split("/").includes("report");
  const navigator = useNavigate();

  const { reportId, projectModificationRequestsId } = useParams();
  const userInfo = useSelector((state) => state.UserInfo.UserInfo);

  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);

  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [
    projectExtensionRequestDetailsId,
    setprojectExtensionRequestDetailsId,
  ] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ProjectModificationRequests = useSelector(
    (state) => state.ProjectModificationRequests.ProjectModificationRequests
  );

  const ListProjectExtensionRequestDetails = useSelector(
    (state) =>
      state.ProjectExtensionRequestDetails.GetListProjectExtensionRequestDetails
  );

  const [
    justificationsforTransferBeneficiary,
    setJustificationsforTransferBeneficiary,
  ] = useState(null);
  const [
    justificationsForTransferEmployee,
    setJustificationsForTransferEmployee,
  ] = useState(null);
  const [File, setFile] = useState(null);

  const AddProjectExtensionRequestDetails = useSelector(
    (state) =>
      state.ProjectExtensionRequestDetails.AddProjectExtensionRequestDetails
  );
  const DeleteProjectExtensionRequestDetails_ = useSelector(
    (state) =>
      state.ProjectExtensionRequestDetails.DeleteProjectExtensionRequestDetails
  );
  const UpdateProjectExtensionRequestDetails = useSelector(
    (state) =>
      state.ProjectExtensionRequestDetails.UpdateProjectExtensionRequestDetails
  );
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "numberMonthsRequestedForExtension",
      ShowStatus: true,
      NmaeColumn: "عدد الأشهر المطلوبة للتمديد",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      // Click: async (e) => {
      //   var objects = JSON.parse(e.target.value);
      //   console.log(objects.projectExtensionRequestDetailsId, "objects");
      //   setprojectExtensionRequestDetailsId(
      //     objects.projectExtensionRequestDetailsId
      //   );
      //   setPopUpBodyStatus(true);
      //   console.log(objects, "objects");
      // },
      // content: "",
      // className: "bi bi-pencil-square",
      // id: "editBtn",
      // title: "تعديل",
      // ShowStatus: false,
      // InitialScreeningAssessment: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteProjectExtensionRequestDetails({
                projectExtensionRequestDetailsId: e.target.value,
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: HandelRoleTransferResult?.iconsDeleteEditExtension,
      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <ProjectExtensionRequestDetailsForm
        projectModificationRequestsId={projectModificationRequestsId}
        reportId={reportId}
      />
    ),

    title: "تفاصبل طلب تمديد المشروع",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <ProjectExtensionRequestDetailsForm
        reportId={reportId}
        projectModificationRequestsId={projectModificationRequestsId}
        projectExtensionRequestDetailsId={projectExtensionRequestDetailsId}
        canEdit="edit"
      />
    ),

    title: "مستفيدين غير مباشرين",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [
    AddProjectExtensionRequestDetails,
    projectExtensionRequestDetailsId,
    ListProjectExtensionRequestDetails,
  ]);

  const SaveData = (statusId) => {
    const formData = new FormData();
    formData.append(
      "JustificationsforTransferBeneficiary",
      justificationsforTransferBeneficiary
    );
    formData.append(
      "JustificationsForTransferEmployee",
      justificationsForTransferEmployee
    );
    formData.append("RequestDetailsStatusId", statusId);
    formData.append(
      "ProjectModificationRequestsId",
      projectModificationRequestsId
    );
    formData.append("RequestAttachment", null);
    formData.append("EmployeeGUID", userInfo.userToken.userGuid);
    formData.append("File", File);

    dispatch(ProcedureForTransferRequest(formData));
  };
  useEffect(() => {
    dispatch(
      GetProjectModificationRequestsById({
        projectModificationRequestsId: projectModificationRequestsId,
      })
    );
  }, [projectModificationRequestsId]);

  useEffect(() => {
    dispatch(
      GetListProjectExtensionRequestDetails({
        projectModificationRequestsId: projectModificationRequestsId,
      })
    );
  }, [
    projectModificationRequestsId,
    AddProjectExtensionRequestDetails,
    DeleteProjectExtensionRequestDetails_,
  ]);

  useEffect(() => {
    dispatch(
      HandelRoleTransfer({
        projectModificationRequestsId: projectModificationRequestsId,
        userGuid: userInfo.userToken.userGuid,
        location: location == true ? "Manager" : "Submitter",
      })
    );
  }, []);
  console.log(
    HandelRoleTransferResult?.submitExtensionRequest,
    "ddddddddfefefef"
  );

  return (
    <>
      {HandelRoleTransferResult?.lodind ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="تفاصبل طلب تمديد المشروع"
            child={[
              <>
                <TableAHSF
                  culomEdite={culomEdite}
                  uniqueValue={"projectExtensionRequestDetailsId"}
                  valueButtonAction={"projectExtensionRequestDetailsId"}
                  URL={`api/ProjectExtensionRequestDetails/GetListProjectExtensionRequestDetails`}
                  UrlBody={{
                    projectModificationRequestsId:
                      projectModificationRequestsId,
                  }}
                  staticKeyEdite={staticKeyEdite}
                  accessor={RequestAccessor}
                  titelTable={""}
                  selectRowNumber={true}
                  checkBoksColumName="اختيار"
                  sort={true}
                  pagination={true}
                  AppStatus={true}
                  // tableBtn={!shouldDisableFields}
                  tableBtn={
                    HandelRoleTransferResult?.iconsAddExtension &&
                    !ListProjectExtensionRequestDetails?.length > 0
                  }
                  sortTable={true}
                  keyNameSort={"dateCreate"}
                  dateKey="dateCreate"
                  dateformat="DD/MM/YYYY h:mm a"
                  arrayNameSort={["applicationNumber"]}
                  search={true}
                  openPopupState={false}
                  DropdownArrayFiltration={[]}
                  DropdownFiltration={false}
                  exportData={true}
                  checkBoks={false}
                  nameColumAction=""
                  total={false}
                  arrayButton={RequestsManagerBtns}
                  ArrayNameDataColum={[]}
                  columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                  ]}
                  PopupOPjectData={PopupOPjectData}
                  popUpTitle={"معلومات الطلب"}
                  popUpBody={
                    <PopupAHSF
                      idssss="SecondarySectors"
                      isPopupOpenStatus={popUpBody.isPopupOpenStatus}
                      isPopupOpenFunction={popUpBody.isPopupOpenFunction}
                      title={popUpBody.title}
                      componentBody={popUpBody.componentBody}
                      maxWidth={popUpBody.maxWidth}
                      maxHeight={popUpBody.maxHeight}
                    />
                  }
                />
                <JustificationsforTransfer
                  projectModificationRequestsId={projectModificationRequestsId}
                />
                {ProjectModificationRequests ? (
                  <>
                    <div className="ContainerJustificationsforTransferForm">
                      <JustificationsforTransferForm
                        projectModificationRequestsId={
                          projectModificationRequestsId
                        }
                        DisabledFieldTransfer={
                          HandelRoleTransferResult?.disabledFieldTransfer
                        }
                        JustificationsForEmployee={
                          HandelRoleTransferResult?.justificationsForEmployee
                        }
                        JustificationsForSubmitter={
                          HandelRoleTransferResult?.justificationsForSubmitter
                        }
                        AttachedAmendmentRequestTransfer={
                          HandelRoleTransferResult?.attachedAmendmentRequestTransfer
                        }
                        location={location}
                        File={ProjectModificationRequests?.requestAttachment}
                        setJustificationsforTransferBeneficiary={
                          setJustificationsforTransferBeneficiary
                        }
                        setJustificationsForTransferEmployee={
                          setJustificationsForTransferEmployee
                        }
                        setFile={setFile}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}

                <div className="ConainerButtonAHSF">
                  {HandelRoleTransferResult?.approvalExtensionRequest ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          if (
                            !justificationsForTransferEmployee ||
                            justificationsForTransferEmployee.trim() === ""
                          ) {
                            missingFields.push("مبررات طلب التمديد (الموظف)");
                          }

                          if (!File || File.length === 0) {
                            missingFields.push("مرفق طلب التعديل");
                          }

                          // if (
                          //   !justificationsforTransferBeneficiary ||
                          //   justificationsforTransferBeneficiary.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (المستفيد)");
                          // }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
                                <div style="text-align: right; direction: rtl; font-size: 16px;">
                                  <ul style="list-style-type: none; padding: 0;">
                                    ${missingFields
                                      .map(
                                        (field) =>
                                          `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                      )
                                      .join("")}
                                      </ul>
                                   </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("0bb0bb2d-86a1-42fb-9cc5-12397857fd90");
                          dispatch(
                            ApprovalOfExtensionRequest({
                              projectModificationRequestsId:
                                projectModificationRequestsId,
                              reportId: reportId,
                            })
                          );
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تمت الموافقة بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="الموافقة على طلب التمديد"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {HandelRoleTransferResult?.returnToEditExtensionRequest ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          // if (
                          //   !justificationsforTransferBeneficiary ||
                          //   justificationsforTransferBeneficiary.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (المستفيد)");
                          // }
                          if (
                            !justificationsForTransferEmployee ||
                            justificationsForTransferEmployee.trim() === ""
                          ) {
                            missingFields.push("مبررات طلب التمديد (الموظف)");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
                                <div style="text-align: right; direction: rtl; font-size: 16px;">
                                  <ul style="list-style-type: none; padding: 0;">
                                    ${missingFields
                                      .map(
                                        (field) =>
                                          `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                      )
                                      .join("")}
                                      </ul>
                                   </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("8f37e7fd-29dd-4579-9ec2-37b50f4a62e2");
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الارجاع للتعديل بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="الارجاع للتعديل"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {HandelRoleTransferResult?.extensionRequestRejected ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          if (!File || File.length === 0) {
                            missingFields.push("مرفق طلب التعديل");
                          }

                          // if (
                          //   !justificationsforTransferBeneficiary ||
                          //   justificationsforTransferBeneficiary.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (المستفيد)");
                          // }
                          // if (
                          //   !justificationsForTransferEmployee ||
                          //   justificationsForTransferEmployee.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (الموظف)");
                          // }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
                                <div style="text-align: right; direction: rtl; font-size: 16px;">
                                  <ul style="list-style-type: none; padding: 0;">
                                    ${missingFields
                                      .map(
                                        (field) =>
                                          `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                      )
                                      .join("")}
                                      </ul>
                                   </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("53e267dc-00ce-4e56-91b7-494b3b200b98");
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم رفص الطلب بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="رفض طلب التمديد"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {HandelRoleTransferResult?.submitExtensionRequest ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];

                          if (
                            !justificationsforTransferBeneficiary ||
                            justificationsforTransferBeneficiary.trim() === ""
                          ) {
                            missingFields.push("مبررات التمديد (المستفيد)");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
                          <div style="text-align: right; direction: rtl; font-size: 16px;">
                            <ul style="list-style-type: none; padding: 0;">
                              ${missingFields
                                .map(
                                  (field) =>
                                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                )
                                .join("")}
                                </ul>
                             </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("762144a1-2932-4f02-b118-dbeac5f53865");
                          dispatch(
                            ChangeStatusByUser({
                              projectModificationRequestsId:
                                projectModificationRequestsId,
                            })
                          );
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تمت التقديم بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                          navigator(`/SRFund/EmployeeTransfers/${reportId}`);
                        }}
                        text="تقديم طلب التمديد"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </>,
            ]}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProjectExtensionRequestDetails;
